module.exports = __webpack_public_path__ + "media/src/images/icons/committee-838bc72c7ebcaba190e8b22e9b3e4b6b.svg";